<mat-dialog-content>
  <div *ngFor="let item of data.data; let i = index" [innerHTML]="getText(item) | translate" class="mt-2"></div>
</mat-dialog-content>

<div class="d-flex justify-content-center" mat-dialog-actions>
  <button class="text-white btn-rounded" color="primary" mat-button mat-raised-button matDialogClose>
    {{ "COMMONS.NEXT" | translate }}
  </button>
</div>
